import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  // Injection des styles responsives + vos styles exacts pour les réseaux sociaux
  useEffect(() => {
    if (!document.getElementById("ppg-footer-styles")) {
      const style = document.createElement("style");
      style.id = "ppg-footer-styles";
      style.textContent = `
        @media(max-width: 900px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media(max-width: 600px) {
          .footer-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
        }
        
        /* Vos styles pour les icônes sociales (conservés à l'identique) */
        .social-links {
          display: flex;
          gap: 10px;
          margin-top: 4px;
          flex-wrap: wrap;
        }
        .social-links a {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          background: #f1f5f9;
          border-radius: 50%;
          font-size: 1.1rem;
          transition: all 0.2s;
          text-decoration: none;
          color: #1e3a8a;
        }
        .social-links a:hover {
          background: #f97316;
          color: #fff;
          transform: translateY(-3px);
        }
        .social-icon {
          background: #f3f4f6;
          border-radius: 50%;
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          transition: all 0.3s ease;
          text-decoration: none;
          color: #4b5563;
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <footer style={s.footer}>
      <div className="container">
        <div className="footer-grid" style={s.grid}>
          {/* Brand */}
          <div style={s.brand}>
            <div style={s.logo}>
              <Link to="/" style={s.logoLink}>
                <img src="/logo12 copie.png" alt="PurePro Group logo" style={s.logoImage} />
              </Link>
            </div>
            <p style={s.brandText}>
              Groupe ivoirien spécialisé dans le nettoyage professionnel et la transformation
              digitale. Votre partenaire de confiance en Côte d'Ivoire.
            </p>
            
            {/* Réseaux sociaux avec vos classes exactes */}
            <div className="social-links">
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fa-brands fa-facebook"></i>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                <i className="fa-brands fa-tiktok"></i>
              </a>
              {/* <a href="#" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                <i className="fa-brands fa-x-twitter"></i>
              </a> */}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <div style={s.colTitle}>Navigation</div>
            {[
              { to: "/", label: "Accueil" },
              { to: "/services", label: "Nos services" },
              { to: "/a-propos", label: "À propos" },
              { to: "/contact", label: "Contact" },
              { to: "/devis", label: "Devis gratuit" },
            ].map(({ to, label }) => (
              <Link key={to} to={to} style={s.link}>
                {label}
              </Link>
            ))}
          </div>

          {/* Entities */}
          <div>
            <div style={s.colTitle}>Nos entités</div>
            <a
              href="https://www.pureprocleaners.ci"
              target="_blank"
              rel="noreferrer"
              style={s.entityLink}
            >
              <div style={{ ...s.entityDot, background: "#2d9b5c" }} />
              PurePro Cleaners
            </a>
            <a
              href="https://www.pureprotechnologie.ci"
              target="_blank"
              rel="noreferrer"
              style={s.entityLink}
            >
              <div style={{ ...s.entityDot, background: "#f97316" }} />
              PurePro Technologie
            </a>
            <div style={s.colTitle2}>Services Cleaners</div>
            {["Nettoyage & Entretien", "Piscines", "Climatisation", "Nuisibles 3D"].map(
              (service, idx) => (
                <div key={`service-${idx}`} style={s.serviceItem}>
                  → {service}
                </div>
              )
            )}
          </div>

          {/* Contact */}
          <div>
            <div style={s.colTitle}>Contact</div>
            {[
              { icon: "📞", text: "+225 05 75 49 64 57 / 07 77 88 00 82" },
              { icon: "✉️", text: "contact@purepro-group.ci" },
              { icon: "🌐", text: "www.purepro-group.ci" },
              { icon: "📍", text: "Abidjan, Côte d'Ivoire" },
              { icon: "⏰", text: "Lun–Sam : 08h–18h" },
              { icon: "🔴", text: "Urgences : 24h/24 – 7j/7" },
            ].map(({ icon, text }) => (
              <div key={text} style={s.contactItem}>
                <span role="img" aria-label={icon === "🔴" ? "urgence" : "icône"}>
                  {icon}
                </span>
                <span>{text}</span>
              </div>
            ))}
            <Link
              to="/devis"
              className="btn btn-primary"
              style={{ marginTop: "16px", fontSize: "13px", justifyContent: "center", width: "100%" }}
            >
              Demander un devis
            </Link>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={s.bottom}>
          <div style={s.bottomLeft}>© {year} PurePro Group — Tous droits réservés</div>
          <div style={s.bottomRight}>
            <span style={s.stat}>20+ Projets</span>
            <span style={s.divider}>·</span>
            <span style={s.stat}>100% Satisfaction</span>
            <span style={s.divider}>·</span>
            <span style={s.stat}>24/7 Support</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

// Objet de styles (inchangé, sauf suppression de l'ancien style "socials" qui n'est plus utilisé)
const s = {
  footer: {
    background: "#061626",
    borderTop: "1px solid rgba(255,255,255,.06)",
    paddingTop: "70px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1.4fr 1fr 1fr 1.2fr",
    gap: "48px",
    paddingBottom: "50px",
    borderBottom: "1px solid rgba(255,255,255,.08)",
  },
  brand: { display: "flex", flexDirection: "column", gap: "16px" },
  logo: { display: "flex", alignItems: "center", gap: "12px" },
  logoLink: { display: "flex", alignItems: "center" },
  logoImage: { height: "44px", width: "auto", display: "block" },
  brandText: {
    fontSize: "13px",
    color: "rgba(255,255,255,.5)",
    lineHeight: "1.7",
    maxWidth: "260px",
  },
  colTitle: {
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "2px",
    textTransform: "uppercase",
    color: "#c9a227",
    marginBottom: "14px",
    marginTop: "4px",
  },
  colTitle2: {
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "2px",
    textTransform: "uppercase",
    color: "rgba(255,255,255,.3)",
    marginBottom: "10px",
    marginTop: "20px",
  },
  link: {
    display: "block",
    fontSize: "13px",
    color: "rgba(255,255,255,.55)",
    textDecoration: "none",
    marginBottom: "8px",
    transition: "color .2s",
  },
  entityLink: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "13px",
    color: "rgba(255,255,255,.7)",
    textDecoration: "none",
    marginBottom: "10px",
    fontWeight: 600,
  },
  entityDot: { width: "8px", height: "8px", borderRadius: "50%", flexShrink: 0 },
  serviceItem: { fontSize: "12px", color: "rgba(255,255,255,.4)", marginBottom: "6px" },
  contactItem: {
    display: "flex",
    gap: "10px",
    alignItems: "flex-start",
    fontSize: "13px",
    color: "rgba(255,255,255,.55)",
    marginBottom: "10px",
  },
  bottom: {
    padding: "24px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "12px",
  },
  bottomLeft: { fontSize: "12px", color: "rgba(255,255,255,.3)" },
  bottomRight: { display: "flex", alignItems: "center", gap: "10px" },
  stat: { fontSize: "12px", color: "rgba(201,162,39,.7)", fontWeight: 600 },
  divider: { color: "rgba(255,255,255,.2)" },
};